// extracted by mini-css-extract-plugin
export default {"link":"MobileChatGPTUsers_link__bsvPX"};